import client from '@/lib/axios-client'
import type {
	ExcludedClustersOutput,
	MonthlyScoreListOutput,
	MonthlyScoresParams,
	RankingOutput,
	RankingParams,
	RankingPersonEventsOutput,
	RankingPersonEventsParams,
	RoleWeightListOutput,
	UpdateMonthlyScoresBody,
	UpdateRoleWeightsBody,
} from '@/types'

const MONTHLY_SCORES_URL = '/scoring/monthly-scores'
const ROLE_WEIGHTS_URL = '/scoring/role-weights'
const RANKING_URL = '/scoring/ranking'

// --- Monthly scores ---

export async function getMonthlyScores(
	params: MonthlyScoresParams,
): Promise<MonthlyScoreListOutput> {
	const response = await client.get(MONTHLY_SCORES_URL, { params })
	return response.data.data
}

export async function updateMonthlyScores(
	body: UpdateMonthlyScoresBody,
): Promise<MonthlyScoreListOutput> {
	const response = await client.put(MONTHLY_SCORES_URL, body)
	return response.data.data
}

// --- Role weights ---

export async function getRoleWeights(): Promise<RoleWeightListOutput> {
	const response = await client.get(ROLE_WEIGHTS_URL)
	return response.data.data
}

export async function updateRoleWeights(
	body: UpdateRoleWeightsBody,
): Promise<RoleWeightListOutput> {
	const response = await client.put(ROLE_WEIGHTS_URL, body)
	return response.data.data
}

// --- Ranking ---

export async function getRanking(
	params: RankingParams,
): Promise<RankingOutput> {
	const response = await client.get(RANKING_URL, { params })
	return response.data.data
}

export async function getRankingPersonEvents(
	personId: string,
	params: RankingPersonEventsParams,
): Promise<RankingPersonEventsOutput> {
	const response = await client.get(
		`${RANKING_URL}/persons/${personId}/events`,
		{
			params,
		},
	)
	return response.data.data
}

export async function getExcludedClusters(): Promise<ExcludedClustersOutput> {
	const response = await client.get(`${RANKING_URL}/excluded-clusters`)
	return response.data.data
}

export async function updateExcludedClusters(
	clusterIds: string[],
): Promise<ExcludedClustersOutput> {
	const response = await client.put(`${RANKING_URL}/excluded-clusters`, {
		clusterIds,
	})
	return response.data.data
}
